"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.UnregisteredMethodInvokedError = exports.UnregisteredComponentUsedError = exports.ReactModuleContainerError = exports.ListenerCallbackError = exports.LazyComponentLoadingError = exports.FileAppenderLoadError = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var ReactModuleContainerError = exports.ReactModuleContainerError = /*#__PURE__*/function (_Error) {
  (0, _inheritsLoose2["default"])(ReactModuleContainerError, _Error);
  function ReactModuleContainerError(message) {
    var _this;
    _this = _Error.call(this, message) || this;
    _this.name = _this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace((0, _assertThisInitialized2["default"])(_this), _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    return _this;
  }
  return ReactModuleContainerError;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
var UnregisteredMethodInvokedError = exports.UnregisteredMethodInvokedError = /*#__PURE__*/function (_ReactModuleContainer) {
  (0, _inheritsLoose2["default"])(UnregisteredMethodInvokedError, _ReactModuleContainer);
  function UnregisteredMethodInvokedError(methodName) {
    var _this2;
    _this2 = _ReactModuleContainer.call(this, "ModuleRegistry.invoke " + methodName + " used but not yet registered") || this;
    _this2.name = 'UnregisteredMethodInvokedError';
    return _this2;
  }
  return UnregisteredMethodInvokedError;
}(ReactModuleContainerError);
var UnregisteredComponentUsedError = exports.UnregisteredComponentUsedError = /*#__PURE__*/function (_ReactModuleContainer2) {
  (0, _inheritsLoose2["default"])(UnregisteredComponentUsedError, _ReactModuleContainer2);
  function UnregisteredComponentUsedError(componentId) {
    var _this3;
    _this3 = _ReactModuleContainer2.call(this, "ModuleRegistry.component " + componentId + " used but not yet registered") || this;
    _this3.name = 'UnregisteredComponentUsedError';
    return _this3;
  }
  return UnregisteredComponentUsedError;
}(ReactModuleContainerError);
var ListenerCallbackError = exports.ListenerCallbackError = /*#__PURE__*/function (_ReactModuleContainer3) {
  (0, _inheritsLoose2["default"])(ListenerCallbackError, _ReactModuleContainer3);
  function ListenerCallbackError(methodName, error) {
    var _this4;
    _this4 = _ReactModuleContainer3.call(this, "Error in listener callback of module registry method: " + methodName) || this;
    _this4.name = 'ListenerCallbackError';
    _this4.stack = _this4.stack + error.stack;
    _this4.originalError = error;
    return _this4;
  }
  return ListenerCallbackError;
}(ReactModuleContainerError);
var LazyComponentLoadingError = exports.LazyComponentLoadingError = /*#__PURE__*/function (_ReactModuleContainer4) {
  (0, _inheritsLoose2["default"])(LazyComponentLoadingError, _ReactModuleContainer4);
  function LazyComponentLoadingError(component, error) {
    var _this5;
    _this5 = _ReactModuleContainer4.call(this, "Error loading moduleRegistry lazy component " + component) || this;
    _this5.name = 'LazyComponentLoadingError';
    _this5.stack = _this5.stack + error.stack;
    _this5.originalError = error;
    return _this5;
  }
  return LazyComponentLoadingError;
}(ReactModuleContainerError);
var FileAppenderLoadError = exports.FileAppenderLoadError = /*#__PURE__*/function (_ReactModuleContainer5) {
  (0, _inheritsLoose2["default"])(FileAppenderLoadError, _ReactModuleContainer5);
  function FileAppenderLoadError(fileUrl) {
    var _this6;
    _this6 = _ReactModuleContainer5.call(this, "FilesAppender failed to load file " + fileUrl) || this;
    _this6.name = 'FileAppenderLoadError';
    return _this6;
  }
  return FileAppenderLoadError;
}(ReactModuleContainerError);